module.exports = __webpack_public_path__ + "img/payment-gateways-pl.556076dd.svg";